import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import DeleteIcon from '../../common/components/DeleteIcon';
import toast from 'react-hot-toast';
import {Modal} from 'react-bootstrap';
import ButtonSubmit from '../../modules/form/ButtonSubmit';
import ButtonCancel from '../../modules/form/ButtonCancel';

interface DeleteFileProps {
    fileId: string;
    onClick: () => Promise<void>;
    onSuccess?: () => void;
}

const DeleteFile = ({fileId, onClick, onSuccess}: DeleteFileProps): JSX.Element => {
    const intl = useIntl();
    const [showModal, setShowModal] = useState(false);

    const handleDelete = async () => {
        try {
            await onClick();
            toast.success(intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.DELETE.SUCCESS'}));
            if (onSuccess) {
                onSuccess();
            }
            window.location.reload();
        } catch (error) {
            toast.error(intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.DELETE.FAIL'}));
        }
    };

    return (
        <>
            <DeleteIcon
                onClick={() => setShowModal(true)}
                tooltip={intl.formatMessage({
                    id: 'ADMIN.DOCUMENTS.TABLE.DELETE',
                })}
            />
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.DELETE.TITLE'})}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {intl.formatMessage(
                            {id: 'ADMIN.DOCUMENTS.TABLE.DELETE.CONFIRMATION'},
                            {fileId: fileId}
                        )}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonCancel
                        onClick={() => setShowModal(false)}
                        textId="ADMIN.DOCUMENTS.TABLE.DELETE.CONFIRMATION.NO"
                    />
                    <ButtonSubmit
                        textId="ADMIN.DOCUMENTS.TABLE.DELETE.CONFIRMATION.YES"
                        disabled={false}
                        isLoading={false}
                        onClick={handleDelete}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteFile;
